import React from 'react'
import Navbar from '../components/navbar/navbar'
import Footer from '../components/footer'

const Faq = () => {
    return (
        <>
            <Navbar transparent={false} />
            <section>
                <div className="container">
                    <h2><span className="font-normal">
                        Frequently Asked Questions (FAQs)</span></h2>

                    <h5 className='mt-5'>1. What is CommercialSPC?</h5>

                    <p className="terms-i">
                        CommercialSPC is a global real estate market place that connects property
                        providers with property users. Our platform allows property provider to
                        advertise commercial properties for sale, vacant commercial space for
                        lease, residential properties for sale or for rent, and multifamily properties
                        for sale.
                    </p>

                    <h5 className='mt-5'>2. How do I use the CommercialSPC website to find properties?</h5>
                    <p className='terms-i'>
                        To search for properties:
                        <ul id="howitworks-list">
                            <li>
                                Visit <a href='https://www.commercialspc.com/' target='_blank' style={{ color: "teal" }}>Commercialspc.com</a>.
                            </li>
                            <li>
                                Use the search functionality to filter listings based on your
                                requirements (e.g., location, property type).
                            </li>
                            <li>
                                Browse through the listings and contact the property owner or agent
                                directly for more information.
                            </li>
                        </ul>
                    </p>


                    <h5 className='mt-5'>3. How can I advertise my commercial property on CommercialSPC?</h5>
                    <p className='terms-i'>
                        To advertise a property:
                        <ul id="howitworks-list">
                            <li>
                                Navigate to the home page on <a href='https://www.commercialspc.com/' target='_blank' style={{ color: "teal" }}>Commercialspc.com</a>.
                            </li>
                            <li>
                                Create an account or log in.
                            </li>
                            <li>
                                Provide detailed information about your property, including photos
                                and contact details.
                            </li>
                            <li>
                                Submit your listing for it to go live on the platform. You will pay a low
                                $10.00 fee for the advertisement and the advertisement lasts for 45
                                days.
                            </li>
                            <li>
                                We currently have a promotion where you can advertise unlimited
                                properties for 45 Days – risk free - at no cost. You will need to use the
                                Promo Code <b>45FREE</b> just before check out. There is a Free Ad link on
                                the home page which provides instruction.
                            </li>
                        </ul>
                    </p>

                    <h5 className='mt-5'>4. Is there a cost to advertise properties on CommercialSPC?</h5>
                    <p className='terms-i'>
                        CommercialSPC offers both free and basic package advertising options. The
                        basic package is $10.00 for each ad however we currently have a promotion
                        for free unlimited ads for 45 days with Promo Code 45FREE before check
                        out.
                    </p>

                    <h5 className='mt-5'>5. What does the free ad offering include?</h5>
                    <p className='terms-i'>
                        The free ad offering allows users to advertise their commercial properties
                        with basic package features. This includes property details, photos, and
                        contact information.
                    </p>

                    <h5 className='mt-5'>6. Are all sales final on CommercialSPC?</h5>
                    <p className='terms-i'>
                        Yes, all sales and transactions conducted through CommercialSPC are
                        considered final. The platform does not offer refunds, so it's essential to
                        review all details and terms before making a purchase or commitment.
                    </p>

                    <h5 className='mt-5'>7. Can I get a refund if I'm not satisfied with a listing or service?</h5>
                    <p className='terms-i'>
                        CommercialSPC maintains a strict no-refund policy. Users are encouraged
                        to thoroughly evaluate listings and services before proceeding, as all sales
                        are final.
                    </p>

                    <h5 className='mt-5'>8. Does CommercialSPC have a global reach?</h5>
                    <p className='terms-i'>
                        Yes! We actively market our website and mobile app in all major markets
                        across the globe. We believe that the world in interconnected like never
                        before so our goal is to help a restaurant owner in London find a restaurant
                        space in Atlanta! Simple!
                    </p>

                    <h5 className='mt-5'>9. How can I ensure my properties reaches a global audience?</h5>
                    <p className='terms-i'>
                        To maximize your property's visibility:
                        <ul id="howitworks-list">
                            <li>
                                Use clear and detailed descriptions.
                            </li>
                            <li>
                                Use clear and detailed descriptions..
                            </li>
                            <li>
                                Share your listing on social media and other online platforms to
                                attract a wider audience.
                            </li>
                            <li>
                                Again, we actively market our website and mobile app in all major
                                markets across the globe to expose your property to a wide national
                                and international audience.
                            </li>
                        </ul>
                    </p>

                    <h5 className='mt-5'>10. Who can I contact for support or more information?</h5>
                    <p className='terms-i'>
                        For assistance or inquiries, visit the <a href='https://www.commercialspc.com/' target='_blank' style={{ color: "teal" }}>Commercialspc.com</a> website and
                        navigate to the contact or support section. Here, you can find the contact
                        form and direct contact information to reach out to our support team.
                    </p>

                    <h5 className='mt-5'>11. Do you have a mobile App?</h5>
                    <p className='terms-i'>
                        Yes! We have a mobile app that can be downloaded at the App Store or
                        Google Play! The app is free and is recommended for "on the go" users.
                    </p>
                </div>


            </section>
            <Footer />

        </>
    )
}

export default Faq;